import * as React from "react";
import { Divider, Header } from "semantic-ui-react";

import { ReportApprovalStatusTypes, ReportDetails } from "../reportsCommon";

interface Props {
    reportDetails: ReportDetails | null;
}

export const ReportWithdrawnInfo: React.FunctionComponent<Props> = (props: Props) => {

    const details = props.reportDetails;

    if (!details) {
        return null;
    }

    if (details.approvalState === ReportApprovalStatusTypes.SystemAdminWithdrawn) {
        return (
            <>
                <Header color="red">THIS REPORT HAS BEEN WITHDRAWN AND AN EDITED VERSION HAS BEEN CREATED</Header>
                <Divider />
            </>
        );
    }

    return null;
};
